import React from 'react';

export default function PoliticaDePrivacidad() {
  return (
    <div className="p-6 max-w-3xl mx-auto text-base leading-relaxed text-neutral-800 dark:text-neutral-200">
      <h1 className="text-3xl font-bold mb-4">Política de Privacidad</h1>
      <p>
        <strong>Última actualización:</strong> 11 de abril de 2025
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Información que recopilamos
      </h2>
      <p>
        No recopilamos datos personales sensibles como nombre, correo
        electrónico, dirección o número de teléfono, salvo que el usuario los
        proporcione explícitamente en funciones específicas.
      </p>
      <p>Podemos recopilar:</p>
      <ul className="list-disc pl-5">
        <li>
          Datos estadísticos del rendimiento de la app (Firebase, Google
          Analytics, etc).
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. Cómo usamos tu información
      </h2>
      <p>La información se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5">
        <li>Mejorar la experiencia de usuario.</li>
        <li>Analizar el uso de la app.</li>
        <li>Mostrar contenido personalizado.</li>
      </ul>
      <p>No vendemos ni compartimos tu información personal con terceros.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Cookies y tecnologías similares
      </h2>
      <p>
        Usamos cookies propias y de terceros para fines analíticos. Puedes
        desactivarlas desde tu navegador.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        4. Almacenamiento de datos
      </h2>
      <p>
        Los datos se almacenan de forma segura en Firebase y otros servicios
        compatibles.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        5. Terceros con acceso limitado
      </h2>
      <p>
        Servicios como Firebase, Google o Apple pueden tener acceso a datos de
        uso anónimos. Consulta sus políticas para más información.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        6. Derechos del usuario
      </h2>
      <p>Como usuario puedes:</p>
      <ul className="list-disc pl-5">
        <li>Acceder, corregir o eliminar tus datos.</li>
        <li>Revocar el consentimiento para su uso.</li>
      </ul>
      <p>
        Escríbenos a{' '}
        <a
          href="mailto:resultadosdebolos@gmail.com"
          className="text-blue-500 underline"
        >
          resultadosdebolos@gmail.com
        </a>{' '}
        para ejercer tus derechos.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        7. Cambios en esta política
      </h2>
      <p>
        Actualizaremos esta política en esta misma página con fecha de revisión.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contacto</h2>
      <p>
        Para cualquier duda, puedes escribirnos a:{' '}
        <a
          href="mailto:resultadosdebolos@gmail.com"
          className="text-blue-500 underline"
        >
          resultadosdebolos@gmail.com
        </a>
      </p>
    </div>
  );
}
